import React, { useEffect } from "react";
import {
  getNotesPack,
  selectNotesPacks,
  getBranchPlan,
} from "../../../../api/plans";
import styled from "styled-components";
import { formatDate } from "../../../../utils";
import Paragraph from "../../../../_components/Text";
import Text from "../../../../_components/Text";
import Buttonn from "../../../../_components/Button";
import AppContext from "../../context";
import LoadingContainer from "../../../../_components/LoadingContainer";
import Modal from "../../../../_components/Modal";
import {
  formatCurrencyValue,
  decimalFormat,
  DifferenceBetweenDatesInDays as diffDates,
} from "../../../../utils";

import EasyButton from "../../../../_components/Button/EasyButton";
import { useShowMe } from "./hooks";
import { toast } from "react-toastify"

const BoxWrapper = styled.div``;

const PeriodTitle = styled.p`
  text-align: center;
  font-weight: 600;
  font-size: 1.4em;
  margin-top: 20px;
`;

const NotePackWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: baseline;
  border-radius: 10px;
  margin-bottm: 10px;
  margin-bottom: 3px;
  background-color: #1ab394;
  padding: 10px;
  color: white;
  font-weight: bold;
  font-size: 1.3em;

  @media (max-width: 500px) {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    min-height: 100px;
  }
`;

const TextTitle = styled.p`
  text-align: center;
  font-size: 1.5em;
  font-weight: bold;
  color: #2554b8;
`;
const DangerTextTitle = styled.p`
  text-align: center;
  font-size: 1.5em;
  font-weight: bold;
  color: #e22126;
`;
const TextWarning = styled.p`
  text-align: left;
  font-size: 1.1em;
`;

const LabelMoreNotes = styled(Paragraph)`
  text-align: center;
  font-size: 1.1em;
  text-decoration: underline;
  cursor: pointer;
  margin-top: 20px;
`;

export default (props) => {
  const context = React.useContext(AppContext);
  const ref = React.useRef(null);
  const handleShowMe = useShowMe();
  const [fetchingPacks, setFetchingPacks] = React.useState(false);
  const [show, ShowModal] = React.useState(false);
  const [showNewRule, ShowModalNewRule] = React.useState(false);
  const [active, setActive] = React.useState(false);
  const [showDisabled, setShowDisabled] = React.useState(false);
  const [packs, setPacks] = React.useState([]);
  const [clickedButtonId, setClickedButtonId] = React.useState([]);
  const [requestStatus, setRequestStatus] = React.useState(false);
  const [messageCheck, setMessageCheck] = React.useState({});
  const [loading, setLoading] = React.useState(false);

  function navigate() {
    window.location.href = "/plan/branch-invoices";
  }

  const checkBranchPlanIsValid = () => {
    setLoading(true);

    getBranchPlan()
      .then((branch_plan) => {
        const isFree = branch_plan.plan === "89723c2c-64d1-40b4-9806-1aa433f91645";
        const isNewFree = branch_plan.plan === "f1818dc9-f799-4ad0-9dc1-37c33ce55265";
        const isFreePlus = branch_plan.plan === "a4366037-9adc-47eb-a3d8-66d2b7699032";
        const isFreePlan = isFree || isFreePlus || isNewFree;

        const hasDateTimeExpired =
          diffDates(new Date(), new Date(branch_plan.end_date)) > 0;

        if (!isFreePlan && hasDateTimeExpired) {
          toast.error(
            "O Seu plano de notas está vencido. Por favor entre em contato com o suporte técnico.",
            {
              position: "top-center",
              toastId: "additional-notes-locked",
            }
          );
        } else {
          getAndOrderNotesPack();
        }
      })
      .catch((error) => {
        console.error("Erro ao verificar plano da filial:", error);
      })
      .finally(() => {
        setTimeout(() => {
          setLoading(false);
        }, 4000);
      });
  };


  async function getAndOrderNotesPack() {
    const { branch_plan } = context.currentBranch;

    setMessageCheck({
      plan_name: branch_plan.plan_name,
      end_date: branch_plan.end_date,
    });

    if (props.disabled === true || branch_plan.status !== 1) {
      setShowDisabled(true);
      return;
    }

    if (props.onClick) {
      props.onClick();
    }

    setFetchingPacks(true);

    let data = [];
    try {
      data = await getNotesPack();
    } catch (error) {
      console.error('Erro ao buscar packs:', error);
      setFetchingPacks(false);
      return;
    }

    if (branch_plan.plan_name !== 'GRÁTIS' || branch_plan.plan_name !== 'Gratuito+') {
      data = data.filter(pack => pack.notes_quantity <= 10);
    }


    const orderedPacks = [];
    const periodsDays = [];

    for (let pack of data) {
      if (!periodsDays.includes(pack.days_to_expire)) {
        periodsDays.push(pack.days_to_expire);
      }
    }

    for (let period of periodsDays) {
      const filter = data.filter((pack) => pack.days_to_expire === period);
      orderedPacks.push({
        period,
        data: filter,
      });
    }

    setPacks(orderedPacks);
    setTimeout(() => {
      setFetchingPacks(false);
    }, 400);

    if (branch_plan.plan_name === 'GRÁTIS' || branch_plan.plan_name === 'Gratuito+') {
      ShowModal(true); // modal para plano 'GRÁTIS'
    } else {
      ShowModalNewRule(true); // modal para os demais planos
    }
  }


  function handleSelectNotesPack(e) {
    const planId = context.currentBranch.branch_plan.plan
    const freePlanId = '89723c2c-64d1-40b4-9806-1aa433f91645'
    const isNewFree = "f1818dc9-f799-4ad0-9dc1-37c33ce55265"

    const freePlusPlanId = 'a4366037-9adc-47eb-a3d8-66d2b7699032'

    const isPaidPlan = planId !== freePlanId && planId !== freePlusPlanId && planId !== isNewFree

    if (isPaidPlan) {
      const currentDate = new Date().toISOString().split("T")[0];
      const endDate = new Date(context.currentBranch.branch_plan.end_date).toISOString().split("T")[0];

      if (endDate <= currentDate) {
        toast.error("O plano está expirado ou inativo. Por favor, renove seu plano.", {
          position: "top-center",
          toastId: "additional-notes-locked",
        });
        return;
      }
    }

    const { id } = e.target;
    setClickedButtonId(id);
    setClickedButtonId(id);
    setRequestStatus(true);

    selectNotesPacks({ notes_pack: id }, props.branchOwnerId).then((data) => {
      window.open(data.invoice_url, "__blank");
      window.location.href = "/plan/branch-invoices";
    });
  }


  function onHide() {
    ShowModal(false);
  }

  function onHideNewRule() {
    ShowModalNewRule(false);
  }

  function clickParagraph() {
    window.open(
      "https://api.whatsapp.com/send?phone=+5511966466526&text=Ol%C3%A1,%20minhas%20notas%20acabaram,%20gostaria%20de%20conhecer%20os%20planos.",
      "__blank"
    );
  }

  useEffect(() => {
    setActive(handleShowMe(context));
  }, [context.currentBranch, location.pathname]);

  if (!props.forceVisible && !active) {
    return <span />;
  }


  return (
    <div className="row">
      <EasyButton
        type="info"
        ref={ref}
        disabled={props.disabled || loading}
        id="a3b5f732-871e-5d64-b430-a89c12d5a1f8"
        onClick={checkBranchPlanIsValid}
        label="Comprar notas avulsas emergenciais"
        icon="fas fa-file-invoice"
      />
      <Modal title="Adquira mais notas" show={show} size="md" onHide={onHide}>
        <LoadingContainer loading={fetchingPacks}>
          <BoxWrapper>
            <TextTitle>Notas avulsas disponíveis</TextTitle>

            {messageCheck.plan !== "89723c2c-64d1-40b4-9806-1aa433f91645" && (
              <div
                style={{
                  backgroundColor: "#fff3cd",
                  border: "1px solid #ffeeba",
                  borderRadius: "5px",
                  padding: "15px",
                  marginBottom: "15px",
                  display: "flex",
                  alignItems: "flex-start",
                  gap: "10px"
                }}
              >
                <i
                  className="fas fa-exclamation-triangle"
                  style={{
                    color: "#856404",
                    fontSize: "1.5em",
                    marginTop: "2px"
                  }}
                ></i>
                <div style={{ color: "#856404", fontSize: "1em" }}>
                  <strong>Notas avulsas são para uso emergencial:</strong><br />
                  Caso sua demanda seja recorrente, considere um plano mensal e evite pagar mais caro por unidade.
                </div>
              </div>
            )}

            {packs.map((pack) => {
              return (
                <div key={`period-${pack.period}`}>
                  <PeriodTitle>{pack.period} dias de validade</PeriodTitle>
                  {pack.data.map((indiviualPack) => {
                    let label = `${indiviualPack.notes_quantity} nota${indiviualPack.notes_quantity > 1 ? 's' : ''} avulsa${indiviualPack.notes_quantity > 1 ? 's' : ''}`;
                    const value = formatCurrencyValue(
                      decimalFormat(indiviualPack.price)
                    );

                    return (
                      <NotePackWrapper key={`additional-package-id-${indiviualPack.id}`}>
                        <span>{label} </span>
                        <span>{value}</span>
                        <button
                          className="btn btn-secondary"
                          onClick={handleSelectNotesPack}
                          id={indiviualPack.id}
                          disabled={requestStatus}
                        >
                          {indiviualPack.id === clickedButtonId
                            ? "Finalizando ..."
                            : "Comprar"}
                          {indiviualPack.id === clickedButtonId ? (
                            <i className="fas fa-spinner fa-spin ml-2"></i>
                          ) : (
                            <span />
                          )}
                        </button>
                      </NotePackWrapper>
                    );
                  })}
                </div>
              );
            })}
          </BoxWrapper>
          <LabelMoreNotes onClick={clickParagraph}>
            Quero adquirir mais notas
          </LabelMoreNotes>
        </LoadingContainer>
      </Modal>

      <Modal title="Adquira mais notas" show={showNewRule} size="md" onHide={onHideNewRule}>
        <LoadingContainer loading={fetchingPacks}>
          <BoxWrapper>
            <DangerTextTitle>Atenção!</DangerTextTitle>
            {
              messageCheck.plan !== "89723c2c-64d1-40b4-9806-1aa433f91645" ? (
                <div>
                  <TextWarning className="text-center">
                    Notas avulsas só podem ser compradas
                    até a <strong>data de vencimento</strong> do seu plano atual.
                  </TextWarning>
                  <TextWarning className="text-center">
                    Qualquer pacote adquirido irá expirar na mesma data do seu vencimento, <strong>sem a possibilidade de acúmulo para períodos futuros.</strong> qualquer dúvida, entre em contato com nosso <a
                      href="https://api.whatsapp.com/send/?phone=5511966466526" target="_blank" >atendimento</a> via WhatsApp.
                  </TextWarning>
                  <TextWarning>
                    Plano mensal ativo: {messageCheck.plan_name}.
                    <br />
                    Próximo vencimento: {formatDate(messageCheck.end_date)}.
                  </TextWarning>
                </div>
              ) : (
                <React.Fragment />
              )}

            {packs.map((pack) => {
              return (
                <div>

                  {pack.data.map((indiviualPack) => {
                    let label = `nota avulsa`;
                    if (indiviualPack.notes_quantity > 1) {
                      label = `${indiviualPack.notes_quantity} notas avulsas`;
                    } else {
                      label = `${indiviualPack.notes_quantity} nota avulsa`;
                    }
                    const value = formatCurrencyValue(
                      decimalFormat(indiviualPack.price)
                    );
                    return (
                      <NotePackWrapper
                        key={`additional-package-id-{indiviualPack.id}`}
                      >
                        <span>{label} </span> <span>{value}</span>{" "}
                        <button
                          className="btn btn-secondary"
                          onClick={handleSelectNotesPack}
                          id={indiviualPack.id}
                          disabled={requestStatus}
                        >
                          {indiviualPack.id === clickedButtonId
                            ? "Finalizando ..."
                            : "Comprar"}
                          {indiviualPack.id === clickedButtonId ? (
                            <i className="fas fa-spinner fa-spin ml-2"></i>
                          ) : (
                            <span />
                          )}
                        </button>
                      </NotePackWrapper>
                    );
                  })}
                </div>
              );
            })}
          </BoxWrapper>
          <LabelMoreNotes onClick={clickParagraph}>
            Quero adquirir mais notas
          </LabelMoreNotes>
        </LoadingContainer>
      </Modal>

      <Modal
        title="Indisponível"
        show={showDisabled}
        onHide={() => setShowDisabled(false)}
      >
        <Text className="text-center py-5">
          Para obter novas notas avulsas você precisa regularizar seu plano, por
          favor regularize-se{" "}
          <Buttonn onClick={navigate} as="text">
            aqui
          </Buttonn>
        </Text>
      </Modal>
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/views/AppViews/Plans/BuyAdditionalNotes/index.jsx